import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { buildPartialFormDataPayload } from '@/utils/fetch';

export const UpdateSpaceValidationSchema = z.object({
  spaceId: z.string({ message: 'Space ID is required' }).min(1),
  name: z.string().optional(),
  description: z.string().optional(),
  icon: z.instanceof(File).optional(),
});
export type TUpdateSpaceValidation = z.infer<typeof UpdateSpaceValidationSchema>;
export type TUpdateSpacePayload = TUpdateSpaceValidation;
export type TUpdateSpaceResponse = ApiResponse<{
  message: string;
}>;

export const updateSpace = async (payload: TUpdateSpacePayload): Promise<TUpdateSpaceResponse> => {
  const url = `/space/${payload.spaceId}`;

  const payloadData = buildPartialFormDataPayload(payload, ['name', 'description', 'icon']);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  return axiosInstance.patch(url, payloadData, config);
};

/**
 * Use Update Space React-Query Hook
 */
type UseUpdateSpaceMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof updateSpace, AxiosErrorCustom>;
};

/**
 * Use Update Space React-Query Hook
 */
export const useUpdateSpaceMutation = ({ mutationConfig }: UseUpdateSpaceMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: updateSpace,
    ...restConfig,
  });
};
